<!--
* @FileDescription: 管理后台侧边栏
* @Author: Rocky
* @Date: 2020-12-25
* @LastEditors: Rocky
* @LastEditTime: 2020-12-25
-->
<template>
  <div id="app-aside">
    <div class="app-aside-control">
      <i :class="controlIcon" @click="toggleAside">{{ controlText }}</i>
    </div>
    <el-menu :default-active="currentIndex" :collapse="controlCollapse">
      <template v-for="(item, i) in sidebarItems">
        <span v-if="item.title" class="app-aside-title" :key="i">{{ item.text }}</span>
        <el-submenu v-if="item.trees && item.trees.length > 0" :index="item.index" :key="i">
          <template slot="title"><i :class="item.icon"></i><span>{{ item.text }}</span></template>
          <el-menu-item-group>
            <el-menu-item v-for="subitem in item.trees" :key="subitem.index" :index="subitem.index"
            :data-path="subitem.path" @click="goMain">{{ subitem.text }}</el-menu-item>
          </el-menu-item-group>
        </el-submenu>
        <el-menu-item v-if="item.trees && item.trees.length <= 0" :data-path="item.path" @click="goMain" :index="item.index" :key="i">
          <i :class="item.icon"></i><span>{{ item.text }}</span>
        </el-menu-item>
      </template>
    </el-menu>
  </div>
</template>

<script>
export default {
  name: 'app-aside',
  data () {
    return {
      controlIcon: 'el-icon-caret-left', // 右箭头 / 左箭头
      controlText: '收起', // 展开 / 收起
      controlCollapse: false, // 侧边栏展开状态
      currentIndex: '1', // 当前高亮 index
      sidebarItems: [
        { title: true, text: '商户管理' },
        { index: '1', path: '/', text: '报关单据上传', icon: 'el-icon-picture', trees: [] }
      ]
    }
  },
  methods: {
    /**
     * 通过路由检查当前高亮链接
     */
    highlightSidebar () {
      let that = this
      let currentLocation = window.location.href.split('#')[1]
      let highlightIndex = '1'
      for (let i = 0; i < that.sidebarItems.length; i++) {
        const lv1 = that.sidebarItems[i]
        if (lv1.path && lv1.path === currentLocation) highlightIndex = lv1.index
        if (lv1.trees) {
          for (let j = 0; j < lv1.trees.length; j++) {
            const lv2 = lv1.trees[j]
            if (lv2.path === currentLocation) highlightIndex = lv2.index
          }
        }
      }
      that.currentIndex = highlightIndex
    },
    /**
     * 跳转到 Main 中对应链接
     */
    goMain (e) {
      let that = this
      let linkPath = e.$el.dataset.path
      if (linkPath !== this.$route.path) {
        that.$router.replace({
          path: e.$el.dataset.path,
          params: {}
        })
      }
    },
    /**
     * 收展侧边栏
     */
    toggleAside () {
      let that = this
      that.controlCollapse = !that.controlCollapse
      that.controlText = that.controlCollapse ? '' : '收起'
      that.controlIcon = that.controlCollapse ? 'el-icon-caret-right' : 'el-icon-caret-left'
      that.$emit('toggleAside', that.controlCollapse)
    }
  },
  mounted () {
    this.highlightSidebar()
  }
}
</script>

<style>
.el-menu {
  background-color: #f1f1f1;
}
.el-submenu__title,
.el-menu-item {
  font-size: 12px;
  height: 50px;
  line-height: 50px;
}
.el-submenu__title:hover,
.el-menu-item:focus, .el-menu-item:hover,
.el-menu-item:hover i,
.el-menu-item.is-active {
  color: #626c79;
  background-color: #fafafa;
}
.app-aside-control > i {
  font-size: 11px;
  font-weight: bold;
  padding: 10px;
  color: #bebebe;
  cursor: pointer;
}
.app-aside-control > i:hover {
  color: #343A40;
}
.app-aside-title {
  padding-left: 10px;
  margin: 8px 0;
  display: block;
  color: #454545;
}
</style>



// WEBPACK FOOTER //
// src/components/frame/Aside.vue